<template>
    <div class="product-detail" v-if="isOpen">
        <div id="detail-modal" class="product-detail--modal tw-rounded tw-w-full md:tw-w-9/12 lg:tw-w-7/12"
            :style="modalOpen ? 'transform: translateY(-50%);' : ''">
            <div
                class="product-detail--modal-header border-section-bottom tw-flex tw-justify-between tw-items-center tw-mx-4 tw-px-2 tw-pt-4 tw-pb-2">
                <h5>
                    รายละเอียดสินค้า
                </h5>
                <div class="tw-px-3 tw-py-1 tw-rounded-lg close-modal-button" @click="closeModal()">
                    <i class="fa fa-close"></i>
                </div>
            </div>
            <div
                class="product-detail--modal-body overflow-auto tw-px-6 tw-my-4 tw-h-4/6 tw-grid tw-gap-2 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-5">
                <div class="tw-col-span-1 image-container tw-rounded-lg">
                    <img class="tw-w-full tw-rounded-lg tw-flex tw-justify-center" :src="product.image_url" />
                </div>
                <div class="tw-col-span-1 lg:tw-col-span-2">
                    <div class="mb-3">
                        <h4 class="font-bold">
                            {{ product.name }}
                        </h4>
                    </div>
                    <div class="mb-3">
                        <label>
                            รายละเอียดสินค้า:
                        </label>
                        <div class="description">
                            <div 
                                class="tw-overflow-auto tw-max-h-40 tw-ml-4" 
                                v-html="product.description"
                                
                            >
                            </div>
                        </div>
                    </div>
                    <div class="tw-flex mb-3">
                        <div class="tw-flex mr-5">
                            <label class="mr-2">
                                ราคาปกติ: 
                            </label>
                            <div>
                                {{ currency ? currency.symbol : '' }} {{ product.price_full }}
                            </div>
                        </div>
                        <div class="tw-flex">
                            <label class="mr-2">
                                ราคาขาย: 
                            </label>
                            <div>
                                {{ currency ? currency.symbol : '' }} {{ product.price }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 tw-flex">
                        <label class="mr-2">
                            หมวดหมู่สินค้า:
                        </label>
                        <div class="tw-self-center">
                            <span class="badge badge-default p-1 m-1 text-xs" v-for="(item, index) in product.categories"
                                :key="index">
                                <i class="mr-1" :class="'fa ' + item.icon"></i> {{ item.title }}
                            </span>
                        </div>
                    </div>
                    <div class="mb-3 mr-2 tw-flex">
                        <label class="mr-2">
                            จํานวนในสต็อก:
                        </label>
                        <div>
                            {{ product.stock_balance }}
                        </div>
                        <!-- <div v-if="editStock" class="p-3 border tw-rounded">
                            <div class="tw-flex tw-flex-1 tw-px-2 tw-justify-center tw-mb-5">
                                <button @click="changeStatus(form, 'status', 'stock_in')"
                                    :class="`toggle-btn-increase ${form.status === 'stock_in' ? 'toggle-btn-increase__active' : ''}`">
                                    เพิ่ม
                                </button>
                                <button @click="changeStatus(form, 'status', 'stock_out')"
                                    :class="`toggle-btn-reduce ${form.status === 'stock_out' ? 'toggle-btn-reduce__active' : ''}`">
                                    ลด
                                </button>
                            </div>
                            <div class="tw-flex tw-items-center tw-justify-center tw-flex-1 tw-px-2">
                                <div class="tw-text-black tw-text-xl">
                                    จำนวนสินค้า :
                                </div>
                                <input v-model="form.quantity" type="number" min="0" :max="form.status == 'stock_out'
                                        ? product.stock_balance
                                        : ''
                                    " class="quantity_stock" />
                            </div>
                            <div class="tw-flex tw-items-center tw-justify-center tw-flex-1 tw-px-2 mt-3">
                                <textarea v-model="form.remark" class="tw-border-transparent p-2" name="remark" id="remark"
                                    cols="50" rows="5" placeholder="หมายเหตุ"></textarea>
                            </div>
                            <div class="mt-2">
                                <button type="button" class="btn btn-sm btn-default px-3" @click="editStock = false">
                                    ยกเลิก
                                </button>
                                <button type="button" class="btn btn-sm btn-success px-3"
                                    :disabled="!form.quantity || form.quantity <= 0"
                                    @click="changeStock"
                                >
                                    อัพเดท
                                </button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="product-detail--modal-footer border-section-top tw-grid tw-gap-2 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-5">
                <div class="tw-col-start-1 md:tw-col-end-3 lg:tw-col-start-2 lg:tw-col-end-4 tw-flex tw-justify-between tw-w-full tw-px-6 tw-py-4">
                    <div class="tw-flex">
                        <label class="mr-2">
                            ปรับจำนวนสินค้า : 
                        </label>
                        <input class="tw-text-xs tw-w-1/3" v-model="form.quantity" type="number" min="0" />
                    </div>
                    <div class="tw-flex">
                        <button 
                            type="button" 
                            class="btn btn-sm btn-outline-danger px-3 tw-mx-2 tw-rounded-lg"
                            @click="changeStock('stock_out')"
                        >
                            <i class="fa fa-minus tw-mr-2"></i> ลดสินค้า
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-outline-success px-3 tw-mx-2 tw-rounded-lg"
                            @click="changeStock('stock_in')"
                        >
                            <i class="fa fa-plus tw-mr-2"></i> เพิ่มสินค้า
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-detail--shade" @click="closeModal()">
        </div>
    </div>
</template>

<script>

export default {
    props: ["isOpen", "product", "shop", "currency"],
    data() {
        return {
            modalOpen: false,
            loading: false,
            editStock: false,
            form: {
                remark: "",
                status: "",
                quantity: 0
            }
        }
    },
    methods: {
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        getData() {
            this.form.product_id = this.product.id;
        },
        closeModal() {
            this.modalOpen = false;
            this.form.quantity = 0;
            setTimeout(() => {
                this.$emit("closeModal");
            }, 400);
        },

        async changeStock(status) {
            this.loading = true;
            this.form.status = status;
            await axios
                .post(`/backend/s/${this.shop}/stocks`, this.form)
                .then(res => {
                    if (res.data.status == "success") {
                        this.onUpdate();
                        this.messageAlert(
                        "success",
                        "สำเร็จ",
                        "อัพเดทสต็อกสินค้าเรียบร้อยแล้ว"
                    );
                    } else if (res.data.status == "error") {
                        this.$swal({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "จำนวนในสต็อกไม่พอ ไม่สามารถเอาออกได้",
                            showConfirmButton: true
                        });
                    }
                    this.form.quantity = 0
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );
                });
        },
        onUpdate() {
            this.editStock = false;
            this.$emit("onUpdate");
        }
    },
    watch: {
        isOpen: function (value) {
            if (value) {
                setTimeout(() => {
                    this.modalOpen = true;
                }, 100);
            }
        },
        product: function (value) {
            this.getData();
        }
    }
}
</script>
<style scoped lang="scss">
.product-detail--shade {
    position: fixed;
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
}

input {
    border: 0;
    outline: 0;
    text-align: center;
    border-bottom: 1px solid #bbb;
}

input:focus {
    outline: none!important;
    border-bottom: 2px solid var(--primary-color);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.product-detail--image {
    max-width: 100%;
    max-height: 300px;
}

.border-section {
    border-bottom: 2px solid #dedede;
}
.close-modal-button {
    cursor: pointer;
    border: 1px solid var(--primary-color);
}

.close-modal-button:hover {
    background-color: var(--primary-color);
    color: #000;
}

.product-detail--modal {
    position: fixed;
    top: 50%;
    margin: 0 auto;
    align-self: center;
    background-color: #fff;
    z-index: 10;
    transform: translateY(200%);
    transition: all 0.7s ease-in;
}

.product-detail--modal-body {
    max-height: 65vh;
    overflow: auto;
}
.border-section-top {
    border-top: 2px solid #dedede;
}

.border-section-bottom {
    border-bottom: 2px solid #dedede;
}

.image-container {
    width: 100%;
    aspect-ratio: 1 / 1;
}

.image-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

@media only screen and (max-width: 767px) {
    .product-detail--modal {
        width: 90%;
        opacity: 100%;
    }
}

@media only screen and (min-width: 768px) {
    .product-detail--modal {
        width: 75%;
        opacity: 100%;
    }
}

.toggle-btn-increase {
    width: 200px;
    background: #fff;
    color: #000;
    cursor: pointer;
    height: 40px;
    margin: 10px;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;

    &__active {
        background: #119b00;
        color: #ffffff;
    }
}

.toggle-btn-reduce {
    width: 200px;
    background: #fff;
    color: #000;
    cursor: pointer;
    height: 40px;
    margin: 10px;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;

    &__active {
        background: #db2727;
        color: #ffffff;
    }
}


.quantity_stock {
    width: 200px;
    border: none;
    border-bottom: 1px solid #000000;
    background: transparent;
    color: rgb(0, 0, 0);
    text-align: center;
    font-size: 26px;
    font-weight: bold;

    @media (min-width: 0px) and (max-width: 992px) {
         width: 150px;
    }
    &:focus {
        background: transparent;
        text-decoration: none;
        outline: none;
    }
}
.shadow-overlay:hover {
    box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.25);
    transition: all 0.25s ease;
}
</style>
